import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'ui';
import AvatarSrc from 'images/profile_pic.svg';
import ChatMessage from 'components/ChatPractice/ChatMessage';

const Chat = ({ answerText, questionData }) => (
  <>
    <div className="Card p-32 mt-24 mb-24">
      <div className="ReplyContainer-header fw-b">
        <Icon name="comments" className="mr-4" />
        {t('questions.question.chat.conversation_with')}
      </div>
      <ChatMessage
        questionChatData={questionData}
        i18n={{ sent_time: t('questions.question.chat.sent_time') }}
        renderAvatar={() => (
          <div className="ReplyContainer--activeReply">
            <img
              alt="Avatar"
              className="ReplyContainer-avatar"
              height="50"
              src={AvatarSrc}
            />
          </div>
        )}
      />
    </div>
    <span className="fw-b mt-24 fz-16">{t('questions.question.response')}</span>
    <div className="Card p-32 mt-24">
      <span className="fz-16 fs-i border-left-solid border-left-1 border-gray pl-16">
        {answerText}
      </span>
    </div>
  </>
);

Chat.propTypes = {
  answerText: PropTypes.string,
  questionData: PropTypes.shape({
    body: PropTypes.string,
    from: PropTypes.string,
    subject: PropTypes.string,
  }),
};

export default Chat;
